import React from 'react';
import { useTranslation } from 'react-i18next';
import LabelCard from './LabelCard';

/** Extraction results: the summary, the controlled facets, and the structured products if any. */
const VisualContextResult = ({ output }) => {
  const { t } = useTranslation();
  const products = output.details?.products || [];
  const chips = [...(output.observed_brands || []), ...(output.categories || []), ...(output.tags || [])];

  return (
    <div className="space-y-3">
      <p className="rounded-xl bg-blue-50 p-4 text-sm dark:bg-blue-950/40">{output.summary}</p>

      {chips.length > 0 && (
        <div className="flex flex-wrap gap-2">
          {chips.map((chip, index) => (
            <span key={`${chip}-${index}`} className="rounded-full bg-blue-100 px-2 py-1 text-xs text-blue-900 dark:bg-blue-900 dark:text-blue-100">{chip}</span>
          ))}
        </div>
      )}

      {output.quality?.limitations?.length > 0 && (
        <p className="text-sm text-amber-700 dark:text-amber-300">{t('Limits')} : {output.quality.limitations.join(' · ')}</p>
      )}

      {(output.labels || []).length > 0 && (
        <div className="space-y-2">
          <h4 className="text-sm font-semibold text-gray-900 dark:text-white">
            {t('Labels read ({{count}})', { count: output.labels.length })}
          </h4>
          {output.labels.map((label, index) => <LabelCard key={`${label.reference_raw || 'label'}-${index}`} label={label} />)}
        </div>
      )}

      {products.length > 0 && (
        <div className="space-y-2">
          <h4 className="text-sm font-semibold text-gray-900 dark:text-white">{t('Structured products and prices')}</h4>
          {products.map((product, index) => (
            <div key={`${product.reference_normalized || product.reference_raw || 'product'}-${index}`} className="rounded-xl border border-gray-200 p-3 dark:border-gray-700">
              <div className="grid gap-3 sm:grid-cols-2">
                <div>
                  <div className="text-xs uppercase text-gray-500">{t('Brand')}</div>
                  <div className="font-medium">{product.brand || t('unknown')}</div>
                </div>
                <div>
                  <div className="text-xs uppercase text-gray-500">{t('Reference')}</div>
                  <div className="font-medium">{product.reference_normalized || product.reference_raw || t('unknown')}</div>
                </div>
              </div>
              <div className="mt-2 flex flex-wrap gap-2">
                {(product.prices || []).map((price, priceIndex) => (
                  <span key={`${price.type}-${priceIndex}`} className="rounded-lg bg-green-100 px-3 py-1 text-sm text-green-900 dark:bg-green-950 dark:text-green-100">
                    {price.amount ?? '—'} {price.currency || ''} · {price.type}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default VisualContextResult;
